module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bank/bri-logo-7e0b69013de2f4ac1f7920958a1c0321.png";